import styles from "./index.module.scss"
import Social from "./social"
import Button from "components/_button/landing"
import Link from "next/link"




const ContactUs = () => {
    return (
        <>
            <section className={styles.contact_us + " flex flex-column gap-10"}>
                <div className={styles.section__contact_us}>
                    <h5 className={styles.title__section + " flex gap-10"}>
                        <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.18211 5.86872C2.65998 -0.627905 12.2849 -0.620403 13.7553 5.87622C14.618 9.68717 12.2474 12.913 10.1694 14.9085C8.66148 16.3638 6.27589 16.3638 4.76051 14.9085C2.68999 12.913 0.319397 9.67967 1.18211 5.86872Z" stroke="#456E9A" />
                            <path d="M5.40625 8.12678L6.53153 9.25206L9.53228 6.25131" stroke="#456E9A" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        آدرس
                    </h5>

                    <div className={styles.address__section}>
                        <p>
                            <span className="fw-700">دفتر پارک علم و فناوری:</span> مشهد - میدان تلویزیون - پارک علم و فناوری
                        </p>
                        <p>
                            <span className="fw-700">دفتر دانشجو:</span> مشهد - بلوار دانشجو - دانشجو 24 - پلاک 43 - طبقه همکف
                        </p>
                    </div>

                    <div className={styles.actions__section + " flex align-i-center gap-10"}>
                        <Link href="#form">
                            <Button btnType="action">
                                درخواست مشاوره رایگان
                            </Button>
                        </Link>
                    </div>
                </div>

                <div className={styles.section__contact_us}>
                    <h5 className={styles.title__section + " flex gap-10"}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.00094 13.2843C1.00094 13.5551 1.06112 13.8334 1.189 14.1043C1.31688 14.3751 1.48238 14.6308 1.70053 14.8716C2.06913 15.2778 2.47535 15.5712 2.93423 15.7592C3.38558 15.9473 3.87454 16.0451 4.40112 16.0451C5.16842 16.0451 5.98838 15.8645 6.85347 15.4959C7.71856 15.1273 8.58365 14.6308 9.44122 14.0065C10.3063 13.3746 11.1263 12.675 11.9086 11.9002C12.6834 11.1178 13.383 10.2979 14.0074 9.44028C14.6242 8.58272 15.1207 7.72515 15.4818 6.8751C15.8429 6.01753 16.0234 5.19757 16.0234 4.41523C16.0234 3.9037 15.9332 3.41473 15.7526 2.96338C15.5721 2.50451 15.2862 2.08325 14.8875 1.70712C14.4061 1.2332 13.8795 1 13.3228 1C13.1122 1 12.9016 1.04514 12.7135 1.13541C12.5179 1.22568 12.3449 1.36108 12.2095 1.55667L10.4643 4.01654C10.3289 4.2046 10.2311 4.37762 10.1634 4.54311C10.0957 4.70109 10.0581 4.85906 10.0581 5.00199C10.0581 5.18253 10.1107 5.36307 10.216 5.53609C10.3138 5.70911 10.4568 5.88965 10.6373 6.07019L11.209 6.66447C11.2918 6.74722 11.3294 6.84501 11.3294 6.96537C11.3294 7.02555 11.3219 7.07821 11.3068 7.13839C11.2842 7.19857 11.2617 7.2437 11.2466 7.28884C11.1112 7.53708 10.878 7.86055 10.547 8.25172C10.2085 8.6429 9.84744 9.04159 9.45627 9.44028C9.05005 9.83898 8.65888 10.2076 8.26018 10.5461C7.86901 10.8771 7.54554 11.1028 7.28977 11.2382C7.25216 11.2532 7.20703 11.2758 7.15437 11.2983C7.09419 11.3209 7.03401 11.3284 6.96631 11.3284C6.83842 11.3284 6.74063 11.2833 6.65788 11.2006L6.08617 10.6364C5.89811 10.4483 5.71756 10.3054 5.54455 10.2151C5.37153 10.1098 5.19851 10.0571 5.01045 10.0571C4.86752 10.0571 4.71707 10.0872 4.55157 10.1549C4.38608 10.2226 4.21306 10.3204 4.02499 10.4483L1.53504 12.2161C1.33945 12.3515 1.20404 12.5095 1.1213 12.6975C1.04607 12.8856 1.00094 13.0737 1.00094 13.2843Z" stroke="#456E9A" strokeMiterlimit="10" />
                        </svg>

                        تلفن تماس
                    </h5>

                    <div className={styles.phone_number__section}>
                        <a href="tel:02191091243">021 - 91091243</a>
                    </div>

                    <div className={styles.operations_phones__section + " flex flex-column gap-10 align-i-center mt-md"}>
                        <div className={styles.phones__operations_phones + " w100"}>
                            <ul className={styles.input_phone_list__phones + " w100"}>
                                <li>
                                    داخلی 203:
                                    <span>
                                        اپراتور شماره 1
                                    </span>
                                </li>

                                <li>
                                    داخلی 209:
                                    <span>
                                        اپراتور شماره 2
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <div className={styles.social__section}>
                            <Social />
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default ContactUs